// ==============================
// NEQRAW — TAXONOMY (FRENCH UI LABELS)
// Single source of truth
// ==============================

/*
  IMPORTANT:
  - DB stores only the `value`
  - UI displays the `label`
  - Never store labels in Firestore
*/

// ------------------
// SUBJECTS (BAC DZ)
// ------------------

export const SUBJECTS = [
  { value: "general", label: "Général" },

  // Languages & Humanities
  { value: "arabic", label: "Arabe" },
  { value: "french", label: "Français" },
  { value: "english", label: "Anglais" },
  { value: "third_foreign_language", label: "Troisième langue étrangère" },
  { value: "amazigh", label: "Amazigh" },
  { value: "islamic_education", label: "Éducation islamique" },
  { value: "history_geography", label: "Histoire-géographie" },
  { value: "philosophy", label: "Philosophie" },

  // Sciences
  { value: "mathematics", label: "Mathématiques" },
  { value: "physical_sciences", label: "Sciences physiques" },
  { value: "natural_sciences", label: "Sciences naturelles" },

  // Tech / Management
  { value: "technology", label: "Technologie" },
  { value: "management", label: "Gestion" },
  { value: "law", label: "Droit" },
  { value: "accounting_finance", label: "Comptabilité et finance" },
] as const;


export type Subject = (typeof SUBJECTS)[number]["value"];

// ------------------
// TRACKS (BAC DZ)
// Students only
// ------------------

export const TRACKS = [
  { value: "science", label: "Sciences expérimentales" },
  { value: "mathematics", label: "Mathématiques" },
  { value: "math_technical", label: "Technique mathématique" },
  { value: "management_economics", label: "Gestion et économie" },
  { value: "foreign_languages", label: "Langues étrangères" },
  { value: "arabic_literature", label: "Lettres et philosophie" },
] as const;

export type Track = (typeof TRACKS)[number]["value"];





// ------------------
// LABEL MAPS (for legacy code)
// ------------------

export const SUBJECT_LABEL = Object.fromEntries(
  SUBJECTS.map((s) => [s.value, s.label])
) as Record<Subject, string>;

export const TRACK_LABEL = Object.fromEntries(
  TRACKS.map((t) => [t.value, t.label])
) as Record<Track, string>;

// Also export simple value arrays (if you want)
export const SUBJECT_VALUES = SUBJECTS.map((s) => s.value) as Subject[];
export const TRACK_VALUES = TRACKS.map((t) => t.value) as Track[];
// ------------------
// HELPERS
// ------------------

export function isValidSubject(value: any): value is Subject {
  return SUBJECTS.some((s) => s.value === value);
}

export function isValidTrack(value: any): value is Track {
  return TRACKS.some((t) => t.value === value);
}

export function getSubjectLabel(value: string): string {
  return SUBJECTS.find((s) => s.value === value)?.label ?? value;
}

export function getTrackLabel(value: string): string {
  return TRACKS.find((t) => t.value === value)?.label ?? value;
}
